




import React, {useState} from 'react';

import "./ContactUsForm.css"




function ContactUsForm() { 
    const [selectedOption, setSelectedOption] = useState('option1');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
      };

      const [checkboxes, setCheckboxes] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
        checkbox5: false,
        checkbox6: false,
      });
    
      const handleCheckboxChange = (checkboxName) => {
        setCheckboxes((prevCheckboxes) => ({
          ...prevCheckboxes,
          [checkboxName]: !prevCheckboxes[checkboxName],
        }));
      };
 

  return <>
        <div className='ContactUsFormContainer'>
            
                <div className='ContactUsFormCardCover'>    

                      <div className='booleancontainer'>
                        <div>
                            <label>
                                <input
                                type="radio"
                                value="option1"
                                checked={selectedOption === 'option1'}
                                onChange={handleOptionChange}
                                />
                               I am interested in learning as an individual
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                type="radio"
                                value="option2"
                                checked={selectedOption === 'option2'}
                                onChange={handleOptionChange}
                                />
                                 I am interested in corporate training or academic solutions for my organization
                            </label>
                            </div>

                        

                            {/* <p>Selected option: {selectedOption}</p> */}
                            </div>
                             {/* END BOOLEAN CONTAINER */}

                             <div className='contactDetailsCover'>  

                                <div className='WholeNamesContainers'>  

                                        <div className='NamesContainer'>
                                                    <div className='ContTitle'>
                                                        <p>First Name*</p>
                                                    </div>
                                                    <div className='ContInputField'>
                                                        <input type='text'></input>
                                                    </div>
                                            </div>
                                            <div className='NamesContainer'>
                                                    <div className='ContTitle'>
                                                        <p>Last Name*</p>
                                                    </div>
                                                    <div className='ContInputField'>
                                                        <input type='text'></input>
                                                    </div>
                                            </div>

                                </div>
                                   

                                    <div className='EmailContainer'>
                                                 <div className='ContTitle'>
                                                        <p>Email*</p>
                                                    </div>
                                                    <div className='ContInputField'>
                                                        <input className='EmailInput' type='text'></input>
                                                    </div>
                                    </div>

                                    <div className='topicsOfInterestsCheck'>        

                                            <p>
                                                Topic of Interest
                                            </p>

                                            {/* <div className='CheckBoxContainer'> 

                                                        <div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox1"
                                                            checked={checkboxes.checkbox1}
                                                            onChange={() => handleCheckboxChange('checkbox1')}
                                                            />
                                                            <label htmlFor="checkbox1">Checkbox 1</label>
                                                        </div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox2"
                                                            checked={checkboxes.checkbox2}
                                                            onChange={() => handleCheckboxChange('checkbox2')}
                                                            />
                                                            <label htmlFor="checkbox2">Checkbox 2</label>
                                                        </div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox3"
                                                            checked={checkboxes.checkbox3}
                                                            onChange={() => handleCheckboxChange('checkbox3')}
                                                            />
                                                            <label htmlFor="checkbox3">Checkbox 3</label>
                                                        </div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox4"
                                                            checked={checkboxes.checkbox4}
                                                            onChange={() => handleCheckboxChange('checkbox4')}
                                                            />
                                                            <label htmlFor="checkbox4">Checkbox 4</label>
                                                        </div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox5"
                                                            checked={checkboxes.checkbox5}
                                                            onChange={() => handleCheckboxChange('checkbox5')}
                                                            />
                                                            <label htmlFor="checkbox5">Checkbox 5</label>
                                                        </div>
                                                        <div>
                                                            <input
                                                            type="checkbox"
                                                            id="checkbox6"
                                                            checked={checkboxes.checkbox6}
                                                            onChange={() => handleCheckboxChange('checkbox6')}
                                                            />
                                                            <label htmlFor="checkbox6">Checkbox 6</label>
                                                        </div>
                                                        </div>

                                            </div> */}
                                            {/* END OF CHECK BOX CONTAINER */}

                                    </div>

                             </div>
                             {/* end of contact details */}

                             <div className='moreinfoSubmit'>   

                                        <button>SUBMIT</button>

                             </div>
                </div>

               
           

        </div>
       
    
  </>
  
  ;
}

export default ContactUsForm;